import { ChangeDetectionStrategy, Component, computed, inject, input, model, output } from '@angular/core';
import { produce } from 'immer';
import { GuidelineService } from 'shared/domain';
import { RichTextEmittedData } from 'shared/feature-rich-text-editor';

import { TextWidget } from '@treetop/shared/model';

import { ICompareWidgetComponent } from '../../widget-component.interface';
import { CompareDescriptionComponent } from './compare-description/compare-description.component';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-compare-text-widget',
  templateUrl: './compare-text-widget.component.html',
  styleUrls: ['./compare-text-widget.component.scss'],
  imports: [CompareDescriptionComponent],
})
export class CompareTextWidgetComponent implements ICompareWidgetComponent<TextWidget> {
  private guidelineService = inject(GuidelineService);

  public widget = input.required<TextWidget>();

  public isEditMode = model(false);
  public isCompareMode = model(false);
  public mergeConflictStatus = input<'conflict' | 'resolved' | undefined>();

  public resolveMergeConflict = output();
  public unresolveMergeConflict = output();

  protected tag = computed(() => {
    return this.widget().localChanges?.tag ?? this.widget().tag;
  });

  protected description = computed(() => {
    if (this.widget().localChanges?.text === '') {
      return null;
    }

    if (this.widget().localChanges?.text) {
      return this.widget().localChanges?.text;
    }

    return this.widget().text;
  });

  protected handleLocalTextChanged(data: RichTextEmittedData) {
    const updatedLocalChanges = produce(this.widget().localChanges || {}, (draft) => {
      draft.text = data?.text;
      draft.references = data?.references;
    });

    this.guidelineService.updateWidgetLocal<TextWidget>(this.widget().uniqueId, updatedLocalChanges);
  }
}
